import { Action } from "../../types/redux";

export interface AppShellState {
  showLeftNavigation: boolean;
}

export interface AppShellPayload {
  showLeftNavigation: boolean;
}

export enum APP_SHELL_ACTION_ENUM {
  SET_SHOW_LEFT_NAVIGATION = "set_show_left_navigation",
}

const initialState: AppShellState = {
  showLeftNavigation: true,
};

const reducer = (
  state = initialState,
  action: Action<APP_SHELL_ACTION_ENUM, AppShellPayload>
) => {
  switch (action.type) {
    case APP_SHELL_ACTION_ENUM.SET_SHOW_LEFT_NAVIGATION:
      return {
        ...state,
        showLeftNavigation: action.payload.showLeftNavigation,
      };
    default:
      return state;
  }
};

export default reducer;
